/**
 *  TrackingModule
 *
 *  Created by legman on 23/04/2018.
 *
 */

/**
 * @class
 * @memberOf P3.tracking
 */
export default class TrackingModule {
    constructor() {
    }

    /**
     * @param {TrackingData} data
     */
    track(data) {
        // override
    }

    isScriptFound() {
        return false;
    }
}